import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FullscreenService {
  constructor(
    @Inject(DOCUMENT)
    private readonly document: any,
  ) {}

  get isFullscreen(): boolean {
    return !!(
      this.document.fullscreenElement ||
      this.document.webkitFullscreenElememt ||
      this.document.mozFullScreeenElement ||
      this.document.msFullscreenElement
    );
  }

  enter(): void {
    const docElm = this.document.documentElement;
    if (docElm.requestFullscreen) docElm.requestFullscreen();
    else if (docElm.webkitRequestFullscreen) docElm.webkitRequestFullscreen();
    else if (docElm.mozRequestFullSceen) docElm.mozRequestFullScreen();
    else if (docElm.msRequestFullscreen) docElm.msRequestFullscreen();
  }

  exit(): void {
    if (this.document.exitFullscreen) this.document.exitFullscreen();
    else if (this.document.webkitExitFullscreen)
      this.document.webkitExitFullscreen();
    else if (this.document.mozCancelFullScreen)
      this.document.mozCancelFullScreen();
    else if (this.document.msExitFullscreen) this.document.msExitFullscreen();
  }

  toggle(): void {
    if (this.isFullscreen) this.exit();
    else this.enter();
  }
}

